import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { StudentImage } from '../models';
import { seasonYear } from '../utils/functions';

export default function usePastImages({ studentId, additionalQuery = {} }) {
  const season = localStorage.getItem(`currentSeason-${studentId}`);

  return useQuery({
    queryKey: [QueryKeys.pastImages, season, studentId],
    queryFn: () => (
      StudentImage
        .includes('poses')
        .selectExtra(['packageId'])
        .extraParams({ pastImages: true })
        .where({ notSiblingImages: true })
        .where({ studentId })
        .where({ forPastImages: true })
        .where(additionalQuery)
        .all()
        .then((res) => {
          if (res.data.length === 0) return [];

          return res
            .data
            .filter((studentImage) => (
              !(studentImage.watermarkUrl || '').includes('missing.png')
            ))
            .sort((a, b) => seasonYear(a.folder) - seasonYear(b.folder));
        })
    ),
    placeholderData: [],
    staleTime: 0,
    enabled: !!studentId,
  });
}
